__webpack_require__.p = "https://devservices.alphabroder.com/threadsy/shopify/apps/threadsy-vue-app/dist/";